import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';

import {
    ShActionItemComponent,
    ShDynamicDialogModule,
    ShFormDateSelectModule,
    ShFormInputWithDroppanelModule,
    ShFormMultiSelectModule,
    ShFormTextInputComponent,
    ShIconModule,
    ShNotificationComponent
} from '@stylehaven/components';
import { DigihavenElementsModule } from '../elements/elements.module';
import { LoadSavedQueryDialogComponent } from './components/load-saved-query-dialog/load-saved-query.component';
import { SaveQueryDialogComponent } from './components/save-query-dialog/save-query-dialog.component';
import { UpdateQueryDialogComponent } from './components/update-query-dialog/update-query-dialog.component';
import { SavedQueriesSandboxService } from './sandbox/saved-queries.sandbox';

@NgModule({
    declarations: [LoadSavedQueryDialogComponent, SaveQueryDialogComponent, UpdateQueryDialogComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        DigihavenElementsModule,
        ShDynamicDialogModule,
        ShFormInputWithDroppanelModule,
        ShFormDateSelectModule,
        ShActionItemComponent,
        ShFormMultiSelectModule,
        ShIconModule,
        TranslateModule.forChild({ extend: true }),
        ShNotificationComponent,
        ShFormTextInputComponent
    ],
    exports: [LoadSavedQueryDialogComponent],
    providers: [SavedQueriesSandboxService]
})
export class DigihavenSavedQueriesModule {}
